import { Separator } from '@ntconsult/aluma-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Legenda do Gantt — obrigatória: com as barras codificadas por status e
 * faturamento, os tons neutros/muted sem legenda parecem "desabilitados".
 * Usa exatamente os mesmos tokens das barras e do marcador.
 */
export function TimelineLegend() {
  const { t } = useTranslation('alocacao');

  const items: { key: string; swatch: ReactNode; label: string }[] = [
    {
      key: 'ativa',
      swatch: <span className="inline-block h-3 w-3 rounded-sm bg-brand-primary" />,
      label: t('linhaDoTempo.legendaAtiva'),
    },
    {
      key: 'futura',
      swatch: (
        <span className="inline-block h-3 w-3 rounded-sm border border-brand-primary border-dashed bg-brand-primary-subtle" />
      ),
      label: t('linhaDoTempo.legendaFutura'),
    },
    {
      key: 'encerrada',
      swatch: <span className="inline-block h-3 w-3 rounded-sm border border-border bg-muted" />,
      label: t('linhaDoTempo.legendaEncerrada'),
    },
    {
      key: 'fimEstimado',
      swatch: (
        <span className="inline-block h-3 w-3 border-border-strong border-r-2 border-dashed" />
      ),
      label: t('linhaDoTempo.legendaFimEstimado'),
    },
    {
      key: 'hoje',
      swatch: <span className="inline-block h-3 w-0.5 bg-info" />,
      label: t('linhaDoTempo.hoje'),
    },
    {
      key: 'sobrealocado',
      swatch: <span className="inline-block h-3 w-3 rounded-sm bg-danger" />,
      label: t('linhaDoTempo.legendaSobrealocado'),
    },
  ];

  return (
    <div className="flex flex-col gap-3">
      <Separator decorative />
      {/* biome-ignore lint/a11y/useSemanticElements: grupo de rótulos visuais, não lista navegável */}
      <div
        role="group"
        aria-label={t('linhaDoTempo.legenda')}
        className="flex flex-wrap items-center gap-x-4 gap-y-2"
      >
        {items.map((item) => (
          <span
            key={item.key}
            className="inline-flex items-center gap-1.5 text-caption text-foreground-muted"
          >
            <span aria-hidden="true" className="inline-flex">
              {item.swatch}
            </span>
            {item.label}
          </span>
        ))}
      </div>
    </div>
  );
}
